import { render, staticRenderFns } from "./AprobacionSolicitud.vue?vue&type=template&id=54d8c233&scoped=true"
import script from "./AprobacionSolicitud.vue?vue&type=script&lang=js"
export * from "./AprobacionSolicitud.vue?vue&type=script&lang=js"
import style0 from "./AprobacionSolicitud.vue?vue&type=style&index=0&id=54d8c233&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d8c233",
  null
  
)

export default component.exports